import React from "react";
import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div className="au-page">
      <div className="au-container">
        {/* Hero Section */}
        <div className="au-hero">
          <div className="au-hero-content">
            <h1 className="au-main-title">About Kitty n' Mice</h1>
            <p className="au-tagline">
              Where Every Thread is Softly Crafted with Love
            </p>
          </div>
          <div className="au-hero-illustration">
            <span className="au-hero-emoji">🐱</span>
            <span className="au-hero-emoji au-emoji-2">🐭</span>
          </div>
        </div>

        {/* Our Story Section */}
        {/* <section className="au-story-section">
          <div className="au-section-header">
            <h2 className="au-section-title">Our Story</h2>
            <div className="au-title-decoration"></div>
          </div>

          <div className="au-story-content">
            <div className="au-story-image">
              <img
                src="/images/about1.jpeg"
                alt="Kitty n Mice - Crafted with Love"
                className="au-story-img"
              />
            </div>
          </div>
        </section> */}

        {/* Founder Section */}
        <section className="au-founder-section">
          <div className="au-founder-card">
            <div className="au-founder-image">
              <img
                src="/images/aboutowner.jpeg"
                alt="Nakul Taneja - Founder of Kitty n' Mice"
                className="au-founder-img"
              />
              <div className="au-founder-badge">Founder</div>
            </div>
            <div className="au-founder-content">
              <h3 className="au-founder-name">Nakul Taneja</h3>
              <p className="au-founder-role">Founder & Visionary</p>
              <p className="au-founder-bio au-highlight-text">
                Little clothes carry big moments.
              </p>
              <p className="au-founder-bio">
                At Kitty n Mice, we create kidswear that feels as good as it
                looks—soft, comfortable, and thoughtfully made for real
                childhood days. From playtime messes to cuddle-time calm, our
                pieces are designed to move with your child, not restrict them.
              </p>
              <p className="au-founder-bio">
                Inspired by the playful friendship of a curious kitty and a
                clever little mouse, our brand celebrates everything childhood
                stands for—comfort, curiosity, and carefree joy. You'll spot
                them in our subtle doodles, adding a gentle touch of fun while
                keeping our designs clean, minimal, and timeless.
              </p>
              {/* <p className="au-founder-bio">
                Nakul Taneja founded Kitty n' Mice with a mission to
                revolutionize children's fashion in India. As a parent himself,
                he understood the importance of soft, comfortable, and safe
                clothing for babies and toddlers.
              </p> */}
              <p className="au-founder-bio">
                "Every thread we use is softly crafted because we believe that
                comfort should never be compromised when it comes to our little
                ones. Quality, safety, and style – these are not just words for
                us, they're promises we keep with every piece we create."
              </p>
              <div className="au-founder-signature">
                <span className="au-signature-text">- Nakul Taneja</span>
              </div>
            </div>
          </div>
        </section>

        {/* Our Values Section */}
        <section className="au-values-section">
          <div className="au-section-header">
            <h2 className="au-section-title">What We Stand For</h2>
            <div className="au-title-decoration"></div>
          </div>

          <div className="au-values-grid">
            <div className="au-value-card au-card-coral">
              <div className="au-value-icon">🌟</div>
              <h3 className="au-value-title">Quality First</h3>
              <p className="au-value-desc">
                Every thread is softly crafted using premium, baby-safe
                materials that are gentle on delicate skin.
              </p>
            </div>

            <div className="au-value-card au-card-blue">
              <div className="au-value-icon">💝</div>
              <h3 className="au-value-title">Made with Love</h3>
              <p className="au-value-desc">
                Each garment is designed and crafted with the care and attention
                we'd give to our own children.
              </p>
            </div>

            <div className="au-value-card au-card-orange">
              <div className="au-value-icon">🛡️</div>
              <h3 className="au-value-title">Safety Always</h3>
              <p className="au-value-desc">
                We use non-toxic, hypoallergenic materials that meet the highest
                safety standards for babies.
              </p>
            </div>

            <div className="au-value-card au-card-navy">
              <div className="au-value-icon">🌱</div>
              <h3 className="au-value-title">Eco-Conscious</h3>
              <p className="au-value-desc">
                Committed to sustainable practices that protect the planet for
                our children's future.
              </p>
            </div>

            <div className="au-value-card au-card-pink">
              <div className="au-value-icon">✨</div>
              <h3 className="au-value-title">Comfort & Style</h3>
              <p className="au-value-desc">
                Blending trendy designs with ultimate comfort so your little
                ones look and feel amazing.
              </p>
            </div>

            <div className="au-value-card au-card-purple">
              <div className="au-value-icon">❤️</div>
              <h3 className="au-value-title">Customer First</h3>
              <p className="au-value-desc">
                Your satisfaction and your child's comfort are at the heart of
                everything we do.
              </p>
            </div>
          </div>
        </section>

        {/* Craftsmanship Section */}
        <section className="au-craft-section">
          <div className="au-section-header">
            <h2 className="au-section-title">Softly Crafted Excellence</h2>
            <div className="au-title-decoration"></div>
          </div>

          <div className="au-craft-content">
            <div className="au-craft-features">
              <div className="au-craft-item">
                <div className="au-craft-number">01</div>
                <div className="au-craft-text">
                  <h4 className="au-craft-heading">Premium Fabrics</h4>
                  <p className="au-craft-desc">
                    We source the finest cotton and blends, ensuring every
                    thread is incredibly soft against baby's sensitive skin.
                  </p>
                </div>
              </div>

              <div className="au-craft-item">
                <div className="au-craft-number">02</div>
                <div className="au-craft-text">
                  <h4 className="au-craft-heading">Expert Stitching</h4>
                  <p className="au-craft-desc">
                    Our skilled artisans use flat seams and gentle stitching
                    techniques to prevent any irritation or discomfort.
                  </p>
                </div>
              </div>

              <div className="au-craft-item">
                <div className="au-craft-number">03</div>
                <div className="au-craft-text">
                  <h4 className="au-craft-heading">Thoughtful Design</h4>
                  <p className="au-craft-desc">
                    Every button, zipper, and snap is carefully placed for easy
                    dressing and maximum comfort throughout the day.
                  </p>
                </div>
              </div>

              <div className="au-craft-item">
                <div className="au-craft-number">04</div>
                <div className="au-craft-text">
                  <h4 className="au-craft-heading">Quality Testing</h4>
                  <p className="au-craft-desc">
                    Each piece undergoes rigorous quality checks to ensure it
                    meets our high standards before reaching your home.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="au-why-section">
          <div className="au-section-header">
            <h2 className="au-section-title">Why Parents Love Us</h2>
            <div className="au-title-decoration"></div>
          </div>

          <div className="au-why-grid">
            <div className="au-why-card">
              <div className="au-why-icon">🌸</div>
              <h3 className="au-why-title">Ultra-Soft Materials</h3>
              <p className="au-why-text">
                Every thread is carefully selected and softly crafted to be
                gentle on your baby's delicate skin, ensuring all-day comfort.
              </p>
            </div>

            <div className="au-why-card">
              <div className="au-why-icon">🎨</div>
              <h3 className="au-why-title">Adorable Designs</h3>
              <p className="au-why-text">
                From playful patterns to classic styles, our collections are
                designed to make your little one look absolutely adorable.
              </p>
            </div>

            <div className="au-why-card">
              <div className="au-why-icon">👕</div>
              <h3 className="au-why-title">Durable Quality</h3>
              <p className="au-why-text">
                Our clothes are made to withstand endless washes and active
                play, maintaining their softness and color.
              </p>
            </div>

            <div className="au-why-card">
              <div className="au-why-icon">💰</div>
              <h3 className="au-why-title">Great Value</h3>
              <p className="au-why-text">
                Premium quality at accessible prices, because every parent
                deserves the best for their little ones.
              </p>
            </div>
          </div>
        </section>

        {/* Mission Section */}
        <section className="au-mission-section">
          <div className="au-mission-card">
            <div className="au-mission-icon">🎯</div>
            <h2 className="au-mission-title">Our Mission</h2>
            <p className="au-mission-text">
              To make every parent's life a little easier and every child's day
              a little more comfortable by providing beautifully designed,
              softly crafted clothing that celebrates the joy of childhood.
            </p>
            <div className="au-mission-quote">
              "Because every tiny thread matters when it comes to your little
              one's comfort."
            </div>
          </div>
        </section>

        {/* Join Us Section */}
        <section className="au-join-section">
          <div className="au-join-content">
            <h2 className="au-join-title">Join the Kitty n' Mice Family</h2>
            <p className="au-join-text">
              Be a part of our Kitty n Mice family to upscale the fashion game
              of your little munchkins
            </p>
            <div className="au-join-buttons">
              <a href="/products" className="au-join-btn au-btn-primary">
                Shop Now
              </a>
              <a href="/contact" className="au-join-btn au-btn-secondary">
                Get in Touch
              </a>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        {/* <section className="au-stats-section">
          <div className="au-stats-grid">
            <div className="au-stat-card">
              <div className="au-stat-number">10,000+</div>
              <div className="au-stat-label">Happy Families</div>
            </div>
            <div className="au-stat-card">
              <div className="au-stat-number">50,000+</div>
              <div className="au-stat-label">Clothes Delivered</div>
            </div>
            <div className="au-stat-card">
              <div className="au-stat-number">100%</div>
              <div className="au-stat-label">Quality Guaranteed</div>
            </div>
            <div className="au-stat-card">
              <div className="au-stat-number">4.8★</div>
              <div className="au-stat-label">Customer Rating</div>
            </div>
          </div>
        </section> */}
      </div>
    </div>
  );
};

export default AboutUs;
